import { z } from "zod";
import { Fetcher } from "../../../fetcher";
import { CognitoIdToken } from "../../users/authTypes";
import { historicalPriceSchema } from "./historicalPrices";
import { CorporateBondId } from "@goodfill/domain-properties";

const schema = z.object({
  // bondCusipId: zCUSIP, // Todo: put back, when fixed on backend
  dailyHistoricalPrices: z.array(historicalPriceSchema),
});

export type ApiGetQueryHistoricalPricesOkResponse = z.infer<typeof schema>;

export interface QueryDailyHistoricalBondPrices {
  bondCusipId: CorporateBondId;
  sinceDate: string; // inclusive. Format example: "2010-12-31"
}

export const queryHistoricalPrices = (
  fetcher: Fetcher,
  cognitoIdToken: CognitoIdToken,
  query: QueryDailyHistoricalBondPrices,
) => {
  return fetcher({
    data: query,
    endpoint: "/bonds/historicalPrices/query",
    method: "POST",
    schema,
    cognitoIdToken,
  });
};
